var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1139 10.3128C13.5389 11.0627 13.0054 12 12.1565 12H1.10651C0.25599 12 -0.275043 11.0612 0.149148 10.3128L5.67422 0.562149C6.09945 -0.188062 7.16448 -0.186703 7.58895 0.562149L13.1139 10.3128ZM6.63158 8.29688C6.0466 8.29688 5.57237 8.77957 5.57237 9.375C5.57237 9.97043 6.0466 10.4531 6.63158 10.4531C7.21657 10.4531 7.69079 9.97043 7.69079 9.375C7.69079 8.77957 7.21657 8.29688 6.63158 8.29688ZM5.62596 4.42158L5.79676 7.60908C5.80476 7.75823 5.92592 7.875 6.07267 7.875H7.1905C7.33725 7.875 7.45841 7.75823 7.4664 7.60908L7.63721 4.42158C7.64585 4.26047 7.51982 4.125 7.36131 4.125H5.90183C5.74332 4.125 5.61732 4.26047 5.62596 4.42158Z",
    fill: "#B89311"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.7cb3368a.svg";
export { ForwardRef as ReactComponent };